import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSession } from '../lib/session'
import { Loading } from '../ui'

/** Exige login; com 2º fator pendente manda para /2fa. */
export default function RequireAuth({ staff }: { staff?: boolean }) {
  const { me, loading, error, retry } = useSession()
  const loc = useLocation()
  if (loading) return <div className="content"><Loading /></div>
  // Falha de rede/servidor não é "deslogado": não joga a pessoa para o login
  if (error) {
    return (
      <div className="content">
        <div className="card empty" role="alert">
          <p>Não conseguimos falar com o servidor agora. Sua conta continua como estava.</p>
          <button className="btn primary sm mt-12" onClick={retry}>Tentar de novo</button>
        </div>
      </div>
    )
  }
  if (!me) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />
  if (me.pending2fa) return <Navigate to={`/2fa?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />
  if (staff && !me.user.isStaff) return <Navigate to="/app" replace />
  return <Outlet />
}
